import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { webBuildInfo } from '../lib/buildInfo';

/** Build identity belongs to this browser bundle, including logged-out and crash screens. */
export function BuildBadge() {
  const { t } = useTranslation('common');
  const [feedback, setFeedback] = useState('');

  async function copyBuild() {
    try {
      await navigator.clipboard.writeText(webBuildInfo.details);
      setFeedback(t('webBuildCopied'));
    } catch {
      setFeedback(t('webBuildCopyFailed'));
    }
  }

  return (
    <>
      <button
        className="build-badge"
        type="button"
        aria-label={`${t('copyWebBuild')}: ${webBuildInfo.label}`}
        title={`${webBuildInfo.details}\n${feedback || t('copyWebBuild')}`}
        onClick={copyBuild}
        onBlur={() => setFeedback('')}
      >
        {webBuildInfo.label}
      </button>
      <span className="build-badge__feedback" role="status">
        {feedback}
      </span>
    </>
  );
}
